const iconCls = "c2livv1bgn";

export { iconCls };
import "./block-icon.style.linaria.module.css";
//# sourceMappingURL=block-icon.style.js.map
